import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Logo from "./Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google-session", { session_id: sessionId })
      .then((r) => navigate("/admin", { state: { user: r.data }, replace: true }))
      .catch(() => navigate("/admin?auth=failed", { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-pulse mb-5 inline-block">
          <Logo size={44} />
        </div>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-mintsoft/80">
          Signing you in with Google…
        </p>
      </div>
    </main>
  );
}
